import React from "react";
import "../Maestra.css";

function MaestraInfoForm({ maestra }) {
  if (!maestra) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="maestra-info">
      <h5>Información Personal</h5>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Clave Única:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.c_unica ? maestra.c_unica : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>RUT:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.rut ? maestra.rut : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Fecha de Nacimiento:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.nacimiento ? maestra.nacimiento : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Nacionalidad:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.nacionalidad ? maestra.nacionalidad : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Estado Civil:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.e_civil ? maestra.e_civil : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Región:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.region ? maestra.region : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Comuna:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.comuna ? maestra.comuna : "-----"}
        </div>
      </div>
      <div className="maestra-info-row">
        <div className="maestra-info-label">
          <strong>Dirección:</strong>
        </div>
        <div className="maestra-info-data">
          {maestra.direccion ? maestra.direccion : "-----"}
        </div>
      </div>
    </div>
  );
}

export default MaestraInfoForm;
